import React from 'react';

interface CuboidsIconProps {
  style?: React.CSSProperties;
}

const CuboidsIcon: React.FC<CuboidsIconProps> = ({ style }) => {
  return (
    <svg style={style} viewBox="0 0 26 30">
      <title>Cuboid Annotation</title>
      <g clipPath="url(#clip0)">
        <path d="M0 7.5L12.99 0l12.99 7.5-12.99 8.1L0 7.5z" fill="#943CFF" />
        <path d="M12.99 15l.6 7.5-.6 7.5L0 22.5v-15L12.99 15z" fill="#FD9D52" />
        <path d="M25.98 7.5v15L12.99 30V15l12.99-7.5z" fill="#DD45D3" />
        <path d="M19.485 18.75L12.99 22.5l-6.495-3.75 6.495-4.05 6.495 4.05z" fill="#943CFF" />
        <path d="M12.99 15l-.3-3.75.3-3.75 6.495 3.75v7.5L12.99 15z" fill="#FD9D52" />
        <path d="M6.495 18.75v-7.5L12.99 7.5V15l-6.495 3.75z" fill="#DD45D3" />
      </g>
      <defs>
        <clipPath id="clip0">
          <path fill="#fff" d="M0 0h25.98v30H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CuboidsIcon;
